import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { getCourses } from "../../../services/course";

export const fetchTeacherCourseData = createAsyncThunk(
  "teacherCourseData/fetchContent",
  async (id) => {
    try {
      const { status, data } = await getCourses(id);

      if (status === 200) {
        let backendData = data?.data;
        return backendData;
      } else {
        toast.error(data?.message);
      }
    } catch (error) {
      console.log(error);
    }
  }
);
